import React, {useContext, useEffect, useState} from 'react';
import {CartContext} from '../components/CartContext';
import {useEnvironment} from '../components/EnvironmentProvider';
import {Link, useLocation} from 'react-router-dom';

function MembershipForm() {
    const env = useEnvironment();
    const {addToCart, emptyCart} = useContext(CartContext);
    const [product, setProduct] = useState(null);
    const [paymentOptions, setPaymentOptions] = useState([]);
    const [selectedPaymentOption, setSelectedPaymentOption] = useState('');
    const [totalFee, setTotalFee] = useState(0);
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        emptyCart();

        const theProduct = env.productCatalog.find(p => p.id === "MBR-32143");
        if (!theProduct) return;

        const options = theProduct.billingOptions || [];
        setPaymentOptions(options);

        if (options.length > 0) {
            const defaultPaymentOption = options[0];
            setSelectedPaymentOption(defaultPaymentOption.id);
            setTotalFee(defaultPaymentOption.periodicBillingAmount);

            const updatedProduct = {...theProduct, paymentOption: defaultPaymentOption};
            setProduct(updatedProduct);
            addToCart(updatedProduct);
        }
    }, [pathname, env.productCatalog]);

    const handleOptionChange = (e) => {
        const selectedOption = paymentOptions.find(option => option.id === e.target.value);
        if (!selectedOption) return;

        setSelectedPaymentOption(selectedOption.id);
        setTotalFee(selectedOption.periodicBillingAmount);

        const updatedProduct = {...product, paymentOption: selectedOption};
        setProduct(updatedProduct);

        emptyCart();
        addToCart(updatedProduct);
    };

    const handleRowClick = (id) => {
        document.getElementById(id)?.click();
    };

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    return (
        <div className="container">
            {/* Header Section */}
            <div className="row mb-4 align-items-center justify-content-center">
                <div className="col-12 col-md-3 text-center">
                    <img src="/bevital_logo_sm.png" alt="Logo" className="img-fluid"/>
                </div>
                <div className="col-12 col-md-5 text-center text-md-start pt-3 pt-md-0">
                    <h1>Membership Agreement</h1>
                    <h3>with Melanie Dorion</h3>
                </div>
            </div>

            {/* Product Description */}
            <div className="row justify-content-center">
                <div className="col-12 col-md-8">
                    <div className="row py-4">
                        <div className="col-12 text-start">
                            <h2>Unlock Ongoing Support for Your Health Journey</h2>
                        </div>
                    </div>

                    {/* Product Features and Bundles */}
                    {product?.bundle?.map((item, index) => (
                        <div key={`bundle_${index}`} className="row pb-2 mb-2">
                            <div className="col-12">
                                <h5 className="mb-0 text-start">{item.name}</h5>
                                <p className="mb-0 text-start">{item.description || ''}</p>
                                {item.disclaimers?.map((disclaimer, disclaimerIndex) => (
                                    <p key={`bundle_disclaimer_${disclaimerIndex}`} className="small text-danger">
                                        {disclaimer.description}
                                    </p>
                                ))}
                            </div>
                        </div>
                    ))}

                    {/* Monthly Fee Summary */}
                    <div className="row pt-3 pb-2 mb-2">
                        <div className="col-8">
                            <h5 className="mb-0 text-start">Monthly Fee:</h5>
                        </div>
                        <div className="col-4 d-flex justify-content-end">
                            <h5>{formatter.format(totalFee)}</h5>
                        </div>
                    </div>

                    {/* Product Disclaimers */}
                    {product?.disclaimers?.map((disclaimer, index) => (
                        <div key={`disclaimer_${index}`} className="row pb-2 mb-2">
                            <div className="col-12">
                                <p><span className="small text-danger">{disclaimer.description}</span></p>
                            </div>
                        </div>
                    ))}

                    {/* Payment Options */}
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-start">
                                <h4>Payment Options</h4>
                            </div>
                        </div>
                        <form>
                            {paymentOptions.map((option) => (
                                <div
                                    key={option.id}
                                    className="row mb-3 bg-white border rounded p-3 clickable-row"
                                    onClick={() => handleRowClick(option.id)}
                                >
                                    <div className="col-2 col-md-1 d-flex align-items-start pe-0">
                                        <input
                                            type="radio"
                                            id={option.id}
                                            name="options"
                                            value={option.id}
                                            className="form-check-input"
                                            checked={selectedPaymentOption === option.id}
                                            onChange={handleOptionChange}
                                        />
                                    </div>
                                    <div className="col-9 col-md-9">
                                        <h5 className="mb-1 text-start">
                                            {product?.name} ({option.name})
                                        </h5>
                                        <p className="mb-0 text-start">{option.description}</p>
                                        {option.disclaimers?.map((disclaimer, disclaimerIndex) => (
                                            <p key={`payment_option_disclaimer_${disclaimerIndex}`}
                                               className="small text-danger">
                                                {disclaimer.description}
                                            </p>
                                        ))}
                                    </div>
                                    <div className="col-3 col-md-2 text-end d-none d-md-block">
                                        <p className="mb-0">
                                            {formatter.format(
                                                option.type === "one-time" ? option.totalAmount : option.periodicBillingAmount
                                            )}
                                        </p>
                                    </div>
                                </div>
                            ))}

                            {/* Next Button */}
                            <div className="d-flex justify-content-center mt-4">
                                <Link to="/package/checkout/{coupon}" className="btn btn-primary btn-lg">
                                    Next
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MembershipForm;
